import * as React from 'react';

import type { SelectRootFloatingValues } from './useSelectRootFloating';

export const SelectRootFloatingContext = React.createContext<SelectRootFloatingValues | null>(null);

SelectRootFloatingContext.displayName = 'SelectRootFloatingContext';

export function useSelectRootFloatingContext() {
    const context = React.useContext(SelectRootFloatingContext);
    if (context === null) {
        throw new Error(
            'useSelectRootFloatingContext must be used within a SelectRootFloatingContext provider.'
        );
    }
    return context;
}
